// Auto-import all JSON files from Decap CMS.
const cmsContext = require.context('./cms/customers', false, /\.json$/);
const cmsCustomers = cmsContext.keys().map((key) => {
  const data = cmsContext(key);
  return {
    id: data.name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''),
    name: data.name,
    logo: data.logo ?? null,
    order: data.order ?? 99,
  };
});

export const customers = cmsCustomers.sort((a, b) => a.order - b.order);
